module.exports = __webpack_public_path__ + "media/img/event/VSF-BG-aa8d7d2dcd20d8bbc0d5dbcd165a141e.jpg";